import React from 'react';

export default class Modal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        className="modal"
      >
        <div className="modal-header">
          {this.props.header}
        </div>
        <div className="modal-body">
          {this.props.body}
        </div>
        <div className="modal-footer">
          {this.props.footer}
        </div>
      </div>
    );
  }
}
